import styled from 'styled-components';
import devices from 'style/breakpoints';
import colors from 'style/palette/palette';

export const Page = styled.div`
	min-height: inherit;
	height: 100%;

	padding: 0px 25px 0px;

	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;

	flex-direction: column;
`;

export const PageTitleBox = styled.div`
	width: 100%;
	display: flex;
	align-items: center;

	> svg {
		cursor: pointer;
		width: 30px;
		height: 30px;
	}
`;

export const PageTitle = styled.h1`
	width: 100%;
	color: ${colors.primaryColor};
	font-weight: 300;
	font-variant: small-caps;
	font-size: 1.75rem;
`;

export const BlackCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
	background-color: rgba(17, 17, 17, 1);
	border: 0.5px solid rgba(255, 255, 255, 0.2);
	border-radius: 1rem;
	padding: 1rem;
`;

export const SubTitle = styled.h2`
	color: ${colors.primaryColor};
	width: 100%;
	font-size: 1rem;
	font-weight: 300;
	font-variant: small-caps;
`;

export const TextInput = styled.input`
	width: 100%;
	background: none;
	color: rgba(255, 255, 255, 1);
	font-size: 1rem;
	font-variant: small-caps;
	border-width: 0 0 1px 0;
	border-color: white;
	border-style: solid;
	color-scheme: dark;
`;

export const InstructionsPlayerCard = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	width: 100%;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 0.3rem;
	padding: 1rem;
`;

export const InstructionsPlayerIcon = styled.div`
	background-color: ${colors.primaryColor};
	width: 3.2rem;
	height: 3rem;
	border-radius: 0.3rem;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const InstructionsPlayerTrack = styled.div`
	display: flex;
	flex-direction: column;
	font-variant: small-caps;
	font-weight: 300;
`;

export const InstructionsPlayerTrackTitle = styled.div`
	color: white;
`;

export const InstructionsPlayerTrackAuthor = styled.div`
	color: ${colors.primaryColor};
	font-size: 0.75rem;
`;

export const ShareBox = styled.div`
	display: flex;
	width: 100%;
	padding: 0.75rem 0;
	flex-direction: column;
	align-items: center;
	gap: 0.75rem;
	border-top: 1px solid white;
`;

export const ShareText = styled.h2`
	font-size: 1rem;
	font-variant: small-caps;
	font-weight: 300;
	color: white;
`;

export const ShareButton = styled.button`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.5rem 1rem;
	background-color: ${colors.primaryColor};
	font-weight: 600;
	text-transform: uppercase;
	border: none;
	border-radius: 5px;
`;

export const CardsBox = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
export const CardsDeck = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const CardDrawButton = styled.button`
	background-color: ${colors.primaryColor};
	border: none;
	border-radius: 5px;
	padding: 0.5rem 1rem;
	font-weight: 600;
	text-transform: uppercase;
	align-self: center;
	cursor: pointer;
`;
